export default "__VITE_ASSET__CPmXll85__"